document.addEventListener('DOMContentLoaded', () => {
  const switchableLanguageEls = document.querySelectorAll('section.switchable-language');

  switchableLanguageEls.forEach(el => {
    const headline = el.querySelector('.headline:not(.easy-language)');
    const headlineEasy = el.querySelector('.headline.easy-language');
    const firstAreaHeadline = el.querySelector('.first-area-headline:not(.easy-language)');
    const firstAreaHeadlineEasy = el.querySelector('.first-area-headline.easy-language');
    const firstAreaContent = el.querySelector('.first-area-content:not(.easy-language)');
    const firstAreaContentEasy = el.querySelector('.first-area-content.easy-language');
    const secondAreaHeadline = el.querySelector('.second-area-headline:not(.easy-language)');
    const secondAreaHeadlineEasy = el.querySelector('.second-area-headline.easy-language');
    const secondAreaContent = el.querySelector('.second-area-content:not(.easy-language)');
    const secondAreaContentEasy = el.querySelector('.second-area-content.easy-language');

    const languageSwitch = el.querySelector('.switch > input');
    languageSwitch.addEventListener('click', () => {
      el.classList.toggle('is-easy-language');
      languageSwitch.toggleAttribute('checked');

      if (el.classList.contains('is-easy-language') && languageSwitch.getAttribute('checked') !== null) {
        headline.setAttribute('aria-hidden', true);
        headlineEasy.setAttribute('aria-hidden', false);
        firstAreaHeadline.setAttribute('aria-hidden', true);
        firstAreaHeadlineEasy.setAttribute('aria-hidden', false);
        firstAreaContent.setAttribute('aria-hidden', true);
        firstAreaContentEasy.setAttribute('aria-hidden', false);
        secondAreaHeadline.setAttribute('aria-hidden', true);
        secondAreaHeadlineEasy.setAttribute('aria-hidden', false);
        secondAreaContent.setAttribute('aria-hidden', true);
        secondAreaContentEasy.setAttribute('aria-hidden', false);
      } else {
        headline.setAttribute('aria-hidden', false);
        headlineEasy.setAttribute('aria-hidden', true);
        firstAreaHeadline.setAttribute('aria-hidden', false);
        firstAreaHeadlineEasy.setAttribute('aria-hidden', true);
        firstAreaContent.setAttribute('aria-hidden', false);
        firstAreaContentEasy.setAttribute('aria-hidden', true);
        secondAreaHeadline.setAttribute('aria-hidden', false);
        secondAreaHeadlineEasy.setAttribute('aria-hidden', true);
        secondAreaContent.setAttribute('aria-hidden', false);
        secondAreaContentEasy.setAttribute('aria-hidden', true);
      }
    });
  });
});
